import {Component} from 'react'
import UserContext from '../utils/UserContext';

class Profile extends Component{

    constructor(props){
        super(props);

        console.log(this.props.name, "Child constructor");

        this.state = {
          userInfo: {
            name: "DUMMY name",
            location: "Zurich",
          },
        };
    }

    async componentDidMount(){

        console.log(this.props.name, "Child Component Did Mount");

        try{
            const data = await fetch("https://api.github.com/users/utkarsh26-t");
            const json = await data.json();

            console.log(json); 

            this.setState({
                userInfo: json
            })
        }
        catch(err){
            console.log(err);
        }

    }

    componentDidUpdate(){
        console.log(this.props.name, "Child component did update called")
    }


    componentWillUnmount(){
        console.log(this.props.name, "Component will unmount called")
    }

    render(){

        const {login:name, avatar_url, id} = this.state.userInfo;

        {console.log(this.props.name, "Child Render")}
        return (
            <div>
                <UserContext.Consumer>
                    {({user}) => <b>Context user: {user.name} -- </b>}
                </UserContext.Consumer>
                {this.props.name}
                <img src={avatar_url}/>
                <h1>{name}</h1>
                <h2>{id}</h2>
            </div>
        )
    }
}

export default Profile;